import PropTypes from 'prop-types';
import React, { memo, useMemo, useState } from 'react';

import { DropDown } from '../../ui-kit';
import CreateModuleModal from '../createModuleModal';

const CREATE_ITEM_ID = 'create';

const ModuleTaskItemDropdown = ({
  modules,
  currentModuleId,
  onChange,
  projectId,
  isPending,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const list = useMemo(() => [
    { id: null, label: 'None' },
    ...modules.map(({ id, name }) => ({ id, label: name })),
    { id: CREATE_ITEM_ID, label: '+ Create', isCreate: true },
  ], [modules]);

  const handleChange = ({ val }) => {
    if (val && val.isCreate) {
      setIsModalOpen(true);
      return;
    }
    onChange(val ? val.id : null);
  };

  const handleCreateSuccess = (module) => {
    setIsModalOpen(false);
    onChange(module.id);
  };

  return (
    <>
      <DropDown
        className="project-task__module-dropdown"
        name="module-dropdown"
        label=""
        placeholder="Module"
        list={list}
        currentItem={currentModuleId}
        onChange={handleChange}
      />
      {isModalOpen && (
        <CreateModuleModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          projectId={projectId}
          onSuccess={handleCreateSuccess}
          isPending={isPending}
        />
      )}
    </>
  );
};

ModuleTaskItemDropdown.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  currentModuleId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  projectId: PropTypes.number.isRequired,
  isPending: PropTypes.bool,
};

ModuleTaskItemDropdown.defaultProps = {
  currentModuleId: null,
  isPending: false,
};

export default memo(ModuleTaskItemDropdown);
